var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayersIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  stroke: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  x: 0,
  y: 0
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#006C8E",
  points: "21.3824205 13.2610149 23.0177897 14.5257963 12 23.0526074 0.982210274 14.5257963 2.61642055 13.2610149 12 20.5226074"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#006C8E",
  points: "12 0.94 13.224069 1.88732294 20.974069 7.88514903 23.0177897 9.46681118 20.974069 11.0484733 13.224069 17.0462994 12 17.9936224 10.775931 17.0462994 3.02593103 11.0484733 0.982210274 9.46681118 3.02593103 7.88514903 10.775931 1.88732294"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#D3F4FF",
  points: "12 3.46898509 4.25 9.46681118 12 15.4646373 19.75 9.46681118"
}))));
export default SvgLayersIcon;